export default __webpack_public_path__ + "static/media/coupon.03688ec0.svg";